import { useMemo } from 'react';

import { type SmartResizeRetryLastVersion } from '../types';

const MAX_VISIBLE_LAST_VERSIONS = 3;
const VISIBLE_BEFORE_OVERFLOW = 2;

export type CollapsedLastVersionThumbnails = {
  overflowCount: number;
  visible: SmartResizeRetryLastVersion[];
};

/** Shows all outputs when ≤3 formats; otherwise first two plus a +N overflow count. */
export const collapseLastVersionThumbnails = (
  lastVersions: SmartResizeRetryLastVersion[],
): CollapsedLastVersionThumbnails => {
  if (lastVersions.length <= MAX_VISIBLE_LAST_VERSIONS) {
    return { overflowCount: 0, visible: lastVersions };
  }

  return {
    overflowCount: lastVersions.length - VISIBLE_BEFORE_OVERFLOW,
    visible: lastVersions.slice(0, VISIBLE_BEFORE_OVERFLOW),
  };
};

export const useCollapseLastVersionThumbnails = (lastVersions: SmartResizeRetryLastVersion[]) =>
  useMemo(() => collapseLastVersionThumbnails(lastVersions), [lastVersions]);
